/**
 * 路由定義
 * 定義所有路由配置（不包含語言前綴）
 */

export const baseRoutes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/invest',
    name: 'Invest',
    component: () => import('../views/Invest.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/invest/success',
    name: 'InvestSuccess',
    component: () => import('../views/InvestSuccess.vue')
  },
  {
    path: '/whitepaper',
    name: 'Whitepaper',
    component: () => import('../views/Whitepaper/WhitepaperView.vue'),
    meta: {
      transition: 'none'
    }
  },
  {
    path: '/whitepaper-old',
    name: 'WhitepaperOld',
    component: () => import('../views/Whitepaper.vue'),
    meta: {
      transition: 'none'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: {
      transition: 'fade'
    }
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import('../views/FAQ.vue'),
    meta: {
      transition: 'fade'
    }
  }
]

// 管理後台路由（不需要語言前綴）
export const adminRoutes = [
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('../views/AdminLogin.vue'),
    meta: {
      requiresAuth: false,
      isAdmin: true
    }
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: () => import('../views/AdminDashboard.vue'),
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: '/admin/referrals',
    name: 'AdminReferrals',
    component: () => import('../views/AdminReferrals.vue'),
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: '/admin/teams',
    name: 'AdminTeams',
    component: () => import('../views/AdminTeams.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      isAdmin: true
    }
  },
  {
    path: '/admin/tokenomics',
    name: 'AdminTokenomics',
    component: () => import('../views/AdminTokenomics.vue'),
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  }
]

